import { render, staticRenderFns } from "./ApiItemDetails.vue?vue&type=template&id=78ccf396&scoped=true"
import script from "./ApiItemDetails.vue?vue&type=script&lang=ts"
export * from "./ApiItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./ApiItemDetails.vue?vue&type=style&index=0&id=78ccf396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccf396",
  null
  
)

export default component.exports